import React, { useEffect, useState } from "react"
import MissingImage from "@/public/images/image-missing.png"
import tooltip from "@/public/icons/tooltip-new.svg"

import { getShortenedUrlwithGeneral, sanitizeUrl } from "@/utils/helper"
import { getConfig } from "@/constants/config"
import ToolTip from "@/components/core/ToolTip/ToolTip"

const StoneTopShelf = props => {
  const {
    comboSkuDetails,
    i18n,
    authorData,
    swatchUrl,
    productCategoryType,
    selectStyleTooltipHandler,
    setSelectStyleTooltip,
    tooltipdata,
    styleTooltip,
    currentSku,
  } = props

  const [general, setGeneral] = useState({})
  const [vanityData, setVanityData] = useState(null)
  const [topSwatchDetail, setTopSwatchDetail] = useState([])
  const [activeValues, setActiveValues] = useState({})
  const [sku, setSku] = useState("")

  const plpPagePath = getShortenedUrlwithGeneral(
    general.plpPagePath ?? "/",
    general
  )

  useEffect(() => {
    const configFn = async () => {
      const { general } = await getConfig()
      setGeneral(general)
    }
    configFn()
  }, [])

  useEffect(() => {
    const findSwatchDetails =
      comboSkuDetails && comboSkuDetails.length > 0
        ? comboSkuDetails.find(item => item.selected_b === true)
        : null
    if (findSwatchDetails) {
      const matchingSku =
        findSwatchDetails && findSwatchDetails["topSwatchDetails_ss"]
          ? findSwatchDetails["topSwatchDetails_ss"].find(sku =>
              sku.startsWith(findSwatchDetails.sku_s + "|")
            )
          : null
      let matchingValues = null
      if (matchingSku) {
        const [sku, vanity, swatch] = matchingSku.split("|")
        matchingValues = { sku, vanity, swatch }
      }
      setActiveValues(matchingValues)
      setTopSwatchDetail(findSwatchDetails["topSwatchDetails_ss"])
      setSku(findSwatchDetails.sku_s)
      setVanityData(findSwatchDetails)
    }
  }, [comboSkuDetails])

  const handleSelect = (sku, vanity, swatch) => {
    setActiveValues({ sku, vanity, swatch })
    const vanityUrl = `${plpPagePath}/${productCategoryType.toLowerCase()}/${
      vanityData.slug_s
    }.html?skuId=${sku}`
    window.history.replaceState({}, "", vanityUrl)
  }
  return (
    <>
      {comboSkuDetails && comboSkuDetails.length > 0 && (
        <div className="product-stoneTop">
          <h3 className="title">
            <span className="lable">
              {authorData && authorData.swatchFilename
                ? authorData.swatchFilename
                : i18n.stoneTop}
              :
            </span>
            <span className="info">
              {activeValues ? activeValues.vanity : null}
            </span>
          </h3>

          <div className="stoneTop-row">
            {topSwatchDetail &&
              topSwatchDetail.map((item, index) => {
                const [vanitysku, vanitymaterial, vanityswatch] =
                  item.split("|")
                if (!vanitysku || !vanitymaterial || !vanityswatch) {
                  return null
                }
                const KUVanityTopSwatch = vanityswatch
                  ? sanitizeUrl(`${swatchUrl}` + vanityswatch)
                  : MissingImage?.src
                return (
                  <div
                    className={`column ${
                      vanitysku === activeValues.sku ? "active" : ""
                    }`}
                    key={`TopSwatch-${index}`}
                    onClick={() =>
                      handleSelect(vanitysku, vanitymaterial, vanityswatch)
                    }
                  >
                    <img
                      onError={e => (e.target.src = MissingImage?.src)}
                      src={KUVanityTopSwatch}
                      className="swatch-img"
                      alt={vanitymaterial}
                    />
                  </div>
                )
              })}
            <span className="tool-tip">
              <img
                src={tooltip?.src}
                className="vanitytooltip"
                onMouseOver={() =>
                  selectStyleTooltipHandler(
                    false,
                    false,
                    false,
                    true,
                    tooltipdata["KUVanityTopSwatchFilename_s"] ?? "n/a"
                  )
                }
                onMouseLeave={() =>
                  setSelectStyleTooltip({
                    shareTooltip: false,
                    colorTooltip: false,
                    finishTooltip: false,
                    vanityTooltip: false,
                  })
                }
              />
              {tooltipdata && tooltipdata["KUVanityTopSwatchFilename_s"] && (
                <div
                  className={`product-select-style__list-tooltip${
                    styleTooltip?.vanityTooltip ? "--show" : "--hide"
                  }`}
                >
                  <div className="product-select-style__list-tooltip-color-wrapper">
                    <ToolTip
                      message={tooltipdata["KUVanityTopSwatchFilename_s"]}
                    />
                  </div>
                </div>
              )}
            </span>
          </div>
        </div>
      )}
    </>
  )
}

export default StoneTopShelf
